// src/components/TallCard.jsx
import React from "react";
import { motion } from "framer-motion";

const TallCard = ({ title, desc, stack, image }) => {
    const imageUrl = require(`../assets/projects/${image}`);
    const imageCss = `linear-gradient(45deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${imageUrl})`;

    return (
        <>
            <motion.div 
                className="tall-card"
                whileHover={{ scale: 0.95, filter: "saturate(1)" }}
                whileTap={{ scale: 0.85, filter: "saturate(1)" }}
                style={{ backgroundImage: imageCss }}>
                    <div className="tags">{stack.map((name, index) => {
                        return <p key={index}>{name}</p>
                    })}</div>
                    <h3>{ title }</h3>
                    <p className="desc">{ desc } </p>
            </motion.div>
        </>
    );
};

export default TallCard;